import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export type QueryKeys =
  | 'page'
  | 'limit'
  | 'programTemplateId'
  | 'programCreatedAtStart'
  | 'programCreatedAtEnd'
  | 'excludeNonVoucherPrograms'
  | 'courseCashProgramsOnly'
  | 'showIndividualApplications'
  | 'applicationStates'
  | 'applicationCreatedAtStart'
  | 'applicationCreatedAtEnd'
  | 'inCollections'
  | 'includePayments'
  | 'paymentStates'
  | 'paymentYear'
  | 'includeCourses'
  | 'coursesBeginDate'
  | 'coursesEndDate'
  | 'employeeId'
  | 'terminatedEmployees'
  | 'excludeTermVerified'
  | 'includeInvoiceDate'
  | 'approverId'
  | 'selectedColumns';

export default class AuthenticatedAdminReportingTasProgramsController extends Controller {
  @tracked page = 1;
  @tracked limit = 50;
  @tracked programTemplateId = '';
  @tracked programCreatedAtStart = '';
  @tracked programCreatedAtEnd = '';
  @tracked excludeNonVoucherPrograms = false;
  @tracked courseCashProgramsOnly = false;
  @tracked showIndividualApplications = false;
  @tracked applicationStates = '';
  @tracked applicationCreatedAtStart = '';
  @tracked applicationCreatedAtEnd = '';
  @tracked inCollections = false;
  @tracked includeCourses = false;
  @tracked coursesBeginDate = '';
  @tracked coursesEndDate = '';
  @tracked includePayments = false;
  @tracked paymentStates = '';
  @tracked paymentYear = '';
  @tracked employeeId = '';
  @tracked terminatedEmployees = false;
  @tracked excludeTermVerified = false;
  @tracked includeInvoiceDate = false;

  @tracked approverId = '';

  // Column selection with sensible defaults (stored as comma-separated string for query params)
  // These must match the property names in AggregatedProgramInstance from the data provider
  @tracked
  selectedColumns = [
    'employeeNameKeyword',
    'employeePayrollIdKeyword',
    'tasProgramInstanceFieldNameKeyword',
    'tasProgramInstanceFieldSchoolInstitutionNameKeyword',
  ].join(',');

  queryParams = [
    'page',
    'limit',
    'programTemplateId',
    'programCreatedAtStart',
    'programCreatedAtEnd',
    'excludeNonVoucherPrograms',
    'courseCashProgramsOnly',
    'showIndividualApplications',
    'applicationStates',
    'applicationCreatedAtStart',
    'applicationCreatedAtEnd',
    'inCollections',
    'includePayments',
    'paymentStates',
    'paymentYear',
    'includeCourses',
    'coursesBeginDate',
    'coursesEndDate',
    'employeeId',
    'terminatedEmployees',
    'excludeTermVerified',
    'includeInvoiceDate',
    'approverId',
    'selectedColumns',
  ];
}
